import { useData } from "./DataContext.js";
import { getSimParam } from "./utils.js";

import Modal from "react-bootstrap/Modal";

export default function PauseModal ()
{
    const gData = useData();
    const pause = getSimParam(gData, "pause"); 
    let pauseIDS = JSON.parse(getSimParam(gData, "pauseIDS"));
    if (pauseIDS === null) pauseIDS = [];

    const globalPause = pause && ! gData.admin;
    const localPause = pauseIDS.includes(gData.groupID) && ! gData.admin;

    let text = "Jeu en pause";
    if (! globalPause) text = "Appel de la Présidence";
    
    return (
	<Modal
	    show={globalPause || localPause}
	    backdrop="static"
	    keyboard={false}
	    centered
	>
	    <Modal.Body>
		<div className="fs-1 fw-bold text-uppercase text-center">{text}</div>
	    </Modal.Body>
	</Modal>
    );
}
